"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var reverse = function reverse(list) {
  return Array.prototype.slice.call(list, 0).reverse();
};

var _default = reverse;
exports["default"] = _default;